import React from "react";
import { Form, DatePicker, Mentions, Button } from 'antd';
import dayjs from "dayjs";

class DayTypeCalendarForm extends React.Component {
    form = {};
    handleCalendarFormSubmit= {};
    handleStartDateChange = {};
    constructor(props) {
        super(props);
        this.handleCalendarFormSubmit = props.handleCalendarFormSubmit;
        this.handleStartDateChange = props.handleStartDateChange;
        this.state = {
            confirmDirty: false,
        };
    }

    handleSubmit = values => {

       this.handleCalendarFormSubmit(values)
    };


    render() {
        const formItemLayout = {
            labelCol: {
                xs: {span: 16},
                sm: {span: 16},
            },
            wrapperCol: {
                xs: {span: 8},
                sm: {span: 8},
            }
            
        };

            return (

                <Form onFinish={this.handleSubmit}  
                labelCol= {{span: 6}}
                labelAlign="left"
                wrapperCol= {{span: 18}}
                initialValues={{InitialDate: dayjs().startOf('year')}}
                    >

                    <Form.Item name="InitialDate" label="Start Date">
                            <DatePicker 
                                onChange={this.handleStartDateChange}
                                format={'YYYY-MM-DD'}
                                selected={dayjs().startOf('year')}
                                
                            />
                    </Form.Item>

                    <Form.Item  wrapperCol={{span:24}}>
                        <Button type="primary" block size={'small'} htmlType="submit">Submit</Button>
                    </Form.Item>

                </Form>
            );
    }
}

export default DayTypeCalendarForm;

